<script setup lang="ts">
import type { TaskFilterStatus } from '~/utils/reportUtils'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const {
  modelValue,
  showStarted = true
} = defineProps<{
  modelValue: TaskFilterStatus
  showStarted?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: TaskFilterStatus]
}>()

const { t } = useI18n()

function updateFilter(value: TaskFilterStatus) {
  emit('update:modelValue', value)
}

const allText = computed(() => t('reports.filters.all'))
const completedText = computed(() => t('reports.filters.completed'))
const startedText = computed(() => t('reports.filters.started'))
const notStartedText = computed(() => t('reports.filters.notStarted'))
</script>

<template>
  <div class="flex flex-col gap-3 pl-1 sm:flex-row sm:items-center sm:gap-6">
    <label class="flex cursor-pointer items-center gap-2">
      <input
        :checked="modelValue === 'all'"
        type="radio"
        name="statusFilter"
        value="all"
        class="border-green-40 text-green-40 focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        @change="updateFilter('all')"
      >
      <span class="text-green-40 text-sm font-medium" v-text="allText" />
    </label>
    <label class="flex cursor-pointer items-center gap-2">
      <input
        :checked="modelValue === 'completed'"
        type="radio"
        name="statusFilter"
        value="completed"
        class="border-green-40 text-green-40 focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        @change="updateFilter('completed')"
      >
      <span class="text-green-40 text-sm font-medium" v-text="completedText" />
    </label>
    <label v-if="showStarted" class="flex cursor-pointer items-center gap-2">
      <input
        :checked="modelValue === 'started'"
        type="radio"
        name="statusFilter"
        value="started"
        class="border-green-40 text-green-40 focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        @change="updateFilter('started')"
      >
      <span class="text-green-40 text-sm font-medium" v-text="startedText" />
    </label>
    <label class="flex cursor-pointer items-center gap-2">
      <input
        :checked="modelValue === 'notStarted'"
        type="radio"
        name="statusFilter"
        value="notStarted"
        class="border-green-40 text-green-40 focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        @change="updateFilter('notStarted')"
      >
      <span class="text-green-40 text-sm font-medium" v-text="notStartedText" />
    </label>
  </div>
</template>

<style scoped>
input[type='radio'] {
  width: 18px;
  height: 18px;
  accent-color: #005850;
  border: 2px solid #005850;
}

input[type='radio']:checked {
  background-color: white;
  border: 3px solid #005850;
  background-image: radial-gradient(circle, #005850, #005850);
  background-size: 8px 8px;
  background-position: center;
  background-repeat: no-repeat;
}

input[type='radio']:focus {
  outline: 2px solid #005850;
  outline-offset: 1px;
}
</style>
